<template>
  <v-fab-transition>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          fixed
          dark
          bottom
          right
          color="primary"
          v-on="on"
          @click="createNewSubmission"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Create a new Submission</span>
    </v-tooltip>
  </v-fab-transition>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import uiHelper from '@/helpers/ui'

export default {
  name: 'DashboardCreateNewSubmission',

  methods: {
    ...mapActions({
      createNewSubmissionState: 'form/createNewSubmission',
      getQuestionsBySection: 'form/getQuestionsBySection'
    }),
    ...mapMutations({
      setSelectedSubmissionToken: 'form/setSelectedSubmissionToken',
      setSelectedSubmissionDetails: 'form/setSelectedSubmissionDetails',
      setSelectedSubmission: 'form/setSelectedSubmission',
      setSelectedSubmissionSection: 'form/setSelectedSubmissionSection'
    }),

    async createNewSubmission() {
      uiHelper.progressBarStatus(true)
      let response = await this.createNewSubmissionState()
      let newSubmission = response.data.payload
      this.setSelectedSubmissionDetails({})
      this.setSelectedSubmission(newSubmission.form)
      this.setSelectedSubmissionSection(newSubmission.form.sections[0])
      await this.getQuestionsBySection({ isPublicForm: this.$_isPublicForm })
      this.$router.push({
        name: 'CreateNewSubmission',
        params: { id: newSubmission.submission_token }
      })
      uiHelper.progressBarStatus(false)
    }
  }
}
</script>
